import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled('div')({
    maxWidth: 688,
});

export const AddressWrapper = styled('div')({
    border: '1px solid #E3E3E3',
    borderRadius: 8,
    padding: '14px 32px',
    marginTop: 24,
    marginBottom: 8,
    '& > *': {
        lineHeight: '24px',
        '&:not(:first-child)': {
            fontWeight: 400,
        },
    },
});

export const TextFieldWrapper = styled('div')({
    marginBottom: 32,
});

export const TextWrapper = styled('div')(({ theme }) => ({
    color: `${theme.legacy.colors.neutralGrey} !important`,
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    textDecoration: 'none',
    color: `${theme.legacy.colors.neutralGrey} !important`,
    '&:hover': {
        textDecoration: 'underline',
    },
    '&:active': {
        textDecoration: 'underline',
    },
}));
